export interface StateOption {
  readonly value: string;
  readonly label: string;
}

export const monthOptions: readonly StateOption[] = [
  { value: "01", label: "Januari" },
  { value: "02", label: "Februari" },
  { value: "03", label: "Maret" },
  { value: "04", label: "April" },
  { value: "05", label: "Mei" },
  { value: "06", label: "Juni" },
  { value: "07", label: "Juli" },
  { value: "08", label: "Agustus" },
  { value: "09", label: "September" },
  { value: "10", label: "Oktober" },
  { value: "11", label: "November" },
  { value: "12", label: "Desember" },
];

export const periodeOptions: readonly StateOption[] = [
  { value: "bulan", label: "Bulan" },
  { value: "tahun", label: "Tahun" },
];

export function getYearsRange(range: number): readonly StateOption[] {
  const currentYear = new Date().getFullYear();
  const years: StateOption[] = []; // Menentukan tipe data StateOption[] untuk array

  for (let i = 0; i < range; i++) {
    const year: string = (currentYear - i).toString(); // Menentukan tipe data string untuk year

    years.push({ value: year, label: year }); // Menambahkan objek StateOption ke dalam array
  }

  return years;
}

// Usage example
